import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type InitialStateType = {
  isCollapsed: boolean;
};

const initialState: InitialStateType = {
  isCollapsed: false,
};

const financeLayoutSlice: any = createSlice({
  name: "financeLayout",
  initialState,
  reducers: {
    setIsCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isCollapsed = action.payload;
    },
  },
});

export const { setIsCollapsed } = financeLayoutSlice.actions;
export default financeLayoutSlice.reducer;
